import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const Step7Certifications = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Licenses & Certifications</h3>
        <p className="text-gray-600">Please provide information about any licenses or certifications you hold</p>
      </div>

      <div>
        <Label>Do you hold any professional licenses or certifications? *</Label>
        <div className="flex gap-4 mt-2">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="has_professional_license"
              value="yes"
              checked={formData.has_professional_license === 'yes'}
              onChange={(e) => handleChange('has_professional_license', e.target.value)}
              required
            />
            Yes
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="has_professional_license"
              value="no"
              checked={formData.has_professional_license === 'no'}
              onChange={(e) => handleChange('has_professional_license', e.target.value)}
            />
            No
          </label>
        </div>
      </div>

      <div>
        <Label>Are you currently CPR certified? *</Label>
        <div className="flex gap-4 mt-2">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="is_cpr_certified"
              value="yes"
              checked={formData.is_cpr_certified === 'yes'}
              onChange={(e) => handleChange('is_cpr_certified', e.target.value)}
              required
            />
            Yes
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="is_cpr_certified"
              value="no"
              checked={formData.is_cpr_certified === 'no'}
              onChange={(e) => handleChange('is_cpr_certified', e.target.value)}
            />
            No
          </label>
        </div>
      </div>

      {(formData.has_professional_license === 'yes' || formData.is_cpr_certified === 'yes') && (
        <div className="bg-gray-50 p-6 rounded-lg space-y-4">
          <h4 className="font-bold text-lg">Certification Details</h4>
          
          <div>
            <Label htmlFor="certifications_list">Please list the name of the certification(s) and year obtained:</Label>
            <Textarea
              id="certifications_list"
              value={formData.certifications_list}
              onChange={(e) => handleChange('certifications_list', e.target.value)}
              rows={3}
              placeholder="e.g., CPR Certification - 2023, First Aid - 2022"
            />
          </div>

          <div>
            <Label htmlFor="cert_institution">Name of Issuing Institution or Organization</Label>
            <Input
              id="cert_institution"
              value={formData.cert_institution}
              onChange={(e) => handleChange('cert_institution', e.target.value)}
            />
          </div>

          <div>
            <Label htmlFor="cert_address">Street Address of Issuing Institution</Label>
            <Input
              id="cert_address"
              value={formData.cert_address}
              onChange={(e) => handleChange('cert_address', e.target.value)}
            />
          </div>

          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <Label htmlFor="cert_city">City</Label>
              <Input
                id="cert_city"
                value={formData.cert_city}
                onChange={(e) => handleChange('cert_city', e.target.value)}
              />
            </div>
            <div>
              <Label htmlFor="cert_state">State</Label>
              <Input
                id="cert_state"
                value={formData.cert_state}
                onChange={(e) => handleChange('cert_state', e.target.value)}
                placeholder="PA"
              />
            </div>
            <div>
              <Label htmlFor="cert_zip">ZIP Code</Label>
              <Input
                id="cert_zip"
                value={formData.cert_zip}
                onChange={(e) => handleChange('cert_zip', e.target.value)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step7Certifications;